import { Injectable } from '@angular/core';
import Log from 'models/log/log.model';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor() { }

  /**
     * Creates a new log.
     * @param log The log instance.
     */
    public create(log: Log): Promise<boolean> {
      return new Promise((resolve: (r: boolean) => any, reject: (e: Error) => any) => {
        console.log(log);
        return resolve(true);
      });
  }

  /**
   * Use only for critical errors. E.g. internal server error, unreachable database etc.
   * @param log The log instance.
   */
  public criticalError(log: Log): Promise<boolean> {
      return new Promise((resolve: (r: boolean) => any, reject: (e: Error) => any) => {
        log.type = 'critical';
        console.log(log);
        return resolve(true);
      });
  }
}
